import { readFileSync } from 'fs';
import indexBy from 'lodash/keyBy';
import compose from 'lodash/flowRight';
import collect from 'webpack-assets';
import {dirname, basename} from 'path';
import {create} from './match/util';
import match from './match';
import path from './match/path';
import serve from './serve';

const addIndexAssets = (assets, index) => {
  if (typeof index === 'boolean') {
    return index ? addIndexAssets(assets, 'index.html') : {};
  }
  if (typeof index !== 'string') {
    throw new TypeError();
  }
  return assets.filter((asset) => {
    return basename(asset.url) === index;
  }).reduce((result, asset) => {
    const entry = dirname(asset.url);
    return {
      ...result,
      [entry]: asset,
      [`${entry}/`]: asset,
    };
  }, {});
};

/**
 * Serve assets generated by webpack.
 * @param {Object} stats Webpack stats object.
 * @returns {Function} Herp.
 */
export function asset(stats, {index = false} = {}) {
  const assets = collect(stats);
  const assetIndex = {
    ...indexBy(assets, asset => {
      return asset.url;
    }),
    ...addIndexAssets(assets, index),
  };
  return create((req) => {
    if (assetIndex[req.url]) {
      req.asset = assetIndex[req.url];
      return true;
    }
    return false;
  });
}

export function request(stats) {
  const assets = collect(stats);
  return function(app) {
    const { request } = app;
    return {
      ...app,
      request(req, res) {
        req.assets = assets;
        request(req, res);
      },
    };
  };
}

/**
 * @param {String} file Path to webpack stats object.
 * @param {Object} options Options passed to `serve`.
 * @returns {Function} Middleware.
 */
export default function(file, options = {
  root: dirname(file),
}) {
  const stats = JSON.parse(readFileSync(file));
  return compose(
    request(stats),
    match(path(stats.publicPath), serve(options))
  );
}
